module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "configuracion"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.monitoringData.rtu), function(section, key_section, index) {
    return (_vm.sectionHasData(section)) ? _c('tbody', {
      key: key_section
    }, [_c('tr', {
      on: {
        "click": function($event) {
          return _vm.showDucto(("ductos" + (section.id_section)))
        }
      }
    }, [_c('td', {
      staticClass: "nombre-ducto"
    }, [_vm._v(_vm._s(section.section_name))]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto"
    }, [(_vm.sectionHasFailure(section, 'online', 0)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("link_off")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'pressure', 0)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("trending_down")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'battery', 10)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("battery_alert")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'site_door', 1)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("lock_open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'cabinet_door', 1)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("lock_open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nombre-ducto",
      attrs: {
        "colspan": "1"
      }
    }, [(_vm.sectionHasFailure(section, 'gps', 0)) ? _c('i', {
      staticClass: "material-icons md-24 fail-icon"
    }, [_vm._v("location_off")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-down pull-right fa-2x",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _vm._l((section.sites), function(site, key_site, index) {
      return (site.timestamp) ? _c('tr', {
        key: key_site,
        class: [("ductos" + (section.id_section)), !site.redraw && 'no-show', !site.enabled && 'site-disabled'],
        staticStyle: {
          "vertical-align": "middle"
        },
        on: {
          "click": function($event) {
            _vm.promptSiteStatus(Object.assign({}, site, {
              id_section: section.id_section,
              key_section: key_section,
              key_site: key_site
            }))
          }
        }
      }, [_c('td', [_vm._v(_vm._s(site.site_name) + " "), (!site.enabled) ? _c('i', {
        staticClass: "material-icons md-24 fail-icon"
      }, [_vm._v("cloud_off")]) : _vm._e()]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'online', 0) ? 'failure' : '']
      }, [_vm._v(_vm._s(site.timestamp))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'pressure', 0) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.pressure))]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.flow))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'battery', 10) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.battery))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'site_door', 1) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.site_door))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'cabinet_door', 1) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.cabinet_door))]), _vm._v(" "), _c('td', {
        class: [_vm.siteHasFailure(site, 'gps', 0) ? 'failure' : ''],
        attrs: {
          "colspan": "1"
        }
      }, [_vm._v(_vm._s(site.gps))])]) : _vm._e()
    }), _vm._v(" "), _c('tr', {
      staticStyle: {
        "height": "10px"
      }
    })], 2) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 leak-table-toggle",
    on: {
      "click": function($event) {
        return _vm.showLeaks()
      }
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "auto",
      "vertical-align": "middle",
      "width": "auto",
      "display": "inline"
    }
  }, [_vm._v("Datos")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down pull-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 leaks-oor no-show",
    staticStyle: {
      "height": "350px",
      "overflow": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.monitoringData.leaks), function(leak, key_leak, index) {
    return _c('tr', {
      key: leak.id_leak,
      class: [],
      staticStyle: {
        "vertical-align": "middle"
      },
      on: {
        "click": function($event) {
          return _vm.promptPublishLeak(leak.id_leak)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(("" + (leak.km))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.lat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.lon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.detection_timestamp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.type === 1 ? 'Apertura' : 'Cierre'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.status === 0 ? 'Generado' : (leak.status === 1 ? ("Publicado por " + (leak.username)) : 'N/A')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leak.timestamp))])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "10px"
    }
  })], 2)])])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), (_vm.modalType === 0) ? _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modalType === 1) ? _c('modal', {
    attrs: {
      "name": "comentario"
    }
  }, [_c('div', {
    staticClass: "modal-body row"
  }, [_c('h5', {
    staticClass: "modal-title text-uppercase",
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v(_vm._s(_vm.modalSite.site_name))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', {
    staticClass: "modal-title",
    staticStyle: {
      "padding": "15px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(("¿Deseas " + (_vm.modalSite.enabled ? 'deshabilitar el rtu? Dejará de producir información referente a su estado.' : 'habilitar el rtu?'))))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group",
      "aria-label": "group button"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "role": "button"
    }
  }, [_vm._v("Cerrar")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "id": "btn-post-site",
      "data-action": "save",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.postSiteEnabled(_vm.modalSite)
      }
    }
  }, [_vm._v("Continuar")])])])])]) : _vm._e(), _vm._v(" "), (_vm.modalType === 2) ? _c('modal', {
    attrs: {
      "name": "publish"
    }
  }, [_c('div', {
    staticClass: "modal-body row"
  }, [_c('h5', {
    staticClass: "modal-title text-uppercase",
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("Publicación manual de fuga")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', {
    staticClass: "modal-title",
    staticStyle: {
      "padding": "15px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s("¿Deseas publicar manualmente la fuga?"))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group",
      "aria-label": "group button"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "role": "button"
    }
  }, [_vm._v("Cerrar")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect waves-light",
    attrs: {
      "type": "button",
      "id": "btn-post-site",
      "data-action": "save",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.postPublishLeak(_vm.publishLeak)
      }
    }
  }, [_vm._v("Continuar")])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "enable-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#comentario-modal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "publish-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#publish-modal"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('h5', {}, [_vm._v("Estado de RTUs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Ducto/Sitios")]), _vm._v(" "), _c('th', [_vm._v("Hora evento")]), _vm._v(" "), _c('th', [_vm._v("Presión")]), _vm._v(" "), _c('th', [_vm._v("Flujo")]), _vm._v(" "), _c('th', [_vm._v("Batería")]), _vm._v(" "), _c('th', [_vm._v("Sitio")]), _vm._v(" "), _c('th', [_vm._v("Gabinete")]), _vm._v(" "), _c('th', [_vm._v("GPS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('h5', {}, [_vm._v("Fugas fuera de rango "), _c('span', {
    staticStyle: {
      "fontSize": "0.5em"
    }
  }, [_vm._v("(Últimas 6 horas)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Km")]), _vm._v(" "), _c('th', [_vm._v("Lat")]), _vm._v(" "), _c('th', [_vm._v("Lon")]), _vm._v(" "), _c('th', [_vm._v("Hora evento")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Hora captura")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('h5', {}, [_vm._v("Configuración")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6"
  }, [_c('h6', [_vm._v("Modo manual de detección de fugas")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "fontSize": "1em"
    }
  }, [_vm._v("Deshabilita la publicación de fugas mientras esté encendido")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6",
    staticStyle: {
      "margin": "auto",
      "text-align": "center",
      "vertical-align": "middle"
    }
  }, [_c('label', {
    staticClass: "switch",
    staticStyle: {
      "margin": "auto",
      "vertical-align": "middle"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "config-leak-manual"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dffbd7e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuracion/Configuracion.vue
// module id = 1721
// module chunks = 6